<template>
  <section class="home-links">
      <div class=" fixed fixed-lg">
        <h2 class="f2 text-bold">{{ molang('home.movotorealestatelistings') }}</h2>
        <h3 class="f3 text-bold">{{ molang('home.homesforsalebystate') }}</h3>
        <ul v-if="home.stateList && home.stateList.length > 0">
            <li v-for="(state, index) in home.stateList" :key="index">
                <a :href="`${glb.appUrl}sitemap/${state.url.toLowerCase()}`">{{ state.stateName }} real estate</a>
            </li>
        </ul>
        <a :href="`${glb.appUrl}sitemap/`">{{ molang('common.viewAll') }} <i class="icon-angle-down"></i></a>
      </div>
  </section>
</template>

<script src="./home-links.js"></script>

<style lang="scss">
@use "./home-links.scss" as *;
</style>